import styled from "styled-components";

export const Container = styled.div`
  text-align: center;
  background-color: rgb(0, 0, 0);
  padding: 100px 30px;
  font-family: "Neue Machina";
  max-width: 1400px;
  color: white;
  margin-inline: auto;
  box-sizing: border-box;
  h1 {
    font-size: 50px;
    font-weight: 500;
  }
`;
export const LinearLine = styled.div`
  height: 1px;
  background: linear-gradient(90deg, #b136b9, #bf4e4e, pink, orange, #e94646);
  margin-bottom: 50px;
  width: 100%;
`;
